import styled from "styled-components";
import { AppBar as AppBarUI, StandardButton, StandardDropdown } from "@trackcode/ui";
import {
  PLATFORM_HEADER_CTA_BG,
  PLATFORM_HEADER_CTA_SHADOW,
  PLATFORM_HEADER_CTA_TEXT,
  PLATFORM_HEADER_GRADIENT,
  PLATFORM_HEADER_MENU_OPEN_BG,
  PLATFORM_HEADER_MENU_OPEN_SHADOW
} from "./platformHeaderConstants";

export const OnDarkButton = styled(StandardButton)`
  && {
    color: #fff;
    background: transparent;
    border-color: transparent;
  }

  svg,
  path {
    fill: currentColor;
  }

  &&:hover:enabled {
    background: rgba(255, 255, 255, 0.14);
    border-color: transparent;
    color: #fff;
  }

  &&:active:enabled {
    background: rgba(255, 255, 255, 0.22);
    border-color: transparent;
    color: #fff;
  }

  &&.button-appearance-subtle.isSelected {
    background: rgba(255, 255, 255, 0.18);
    border-color: transparent;
    color: #fff;
  }

  &&.button-tab-focus {
    box-shadow: 0 0 0 0.16em rgba(255, 255, 255, 0.35);
  }
`;

export const PlatformHeaderCtaButton = styled(StandardButton)`
  && {
    background: ${PLATFORM_HEADER_CTA_BG};
    border-color: ${PLATFORM_HEADER_CTA_BG};
    color: ${PLATFORM_HEADER_CTA_TEXT};
    box-shadow: ${PLATFORM_HEADER_CTA_SHADOW};
    font-weight: 600;
    border-radius: 20px;
  }

  &&:hover:enabled {
    background: #f4f4f4;
    border-color: #f4f4f4;
    color: ${PLATFORM_HEADER_CTA_TEXT};
  }

  &&:active:enabled {
    background: #ebebeb;
    border-color: #ebebeb;
    color: ${PLATFORM_HEADER_CTA_TEXT};
  }

  &&:disabled {
    background: rgba(255, 255, 255, 0.5);
    border-color: transparent;
    color: rgba(0, 90, 84, 0.45);
    box-shadow: none;
    cursor: not-allowed;
  }

  &&.button-tab-focus {
    box-shadow: 0 0 0 0.16em rgba(255, 255, 255, 0.45);
  }
`;

export const PlatformAppBarUI = styled(AppBarUI)`
  && {
    min-height: 50px;
    background-image: ${({ $menuOpen }) =>
      $menuOpen ? PLATFORM_HEADER_MENU_OPEN_BG : PLATFORM_HEADER_GRADIENT};
    box-shadow: ${({ $menuOpen }) =>
      $menuOpen ? PLATFORM_HEADER_MENU_OPEN_SHADOW : "none"};
    transition: background-image 200ms ease, box-shadow 200ms ease;
  }

  /* Right slot: room for CTA without covering the center area */
  && > div:first-child > div:first-child > div:last-child {
    max-width: none;
    min-width: 0;
    margin-left: auto;
    flex: 0 1 auto;
    justify-content: flex-end;
    gap: 8px;
    padding-right: 6px;
  }

  /* Center search must not block left controls (burger / mandant) */
  && > div:first-child > div:first-child > div:nth-child(2) {
    pointer-events: none;
  }

  && > div:first-child > div:first-child > div:nth-child(2) > * {
    pointer-events: auto;
  }
`;

export const PlatformAppBarShell = styled.div`
  width: 100%;

  ${({ $onDark }) =>
    $onDark
      ? `
    [class*="User"] {
      border-left-color: rgba(255, 255, 255, 0.28);
    }
  `
      : ""}
`;

export const OnDarkDropdown = styled(StandardDropdown)`
  && button {
    color: #fff;
    background: transparent;
    border-color: transparent;
  }

  && button svg,
  && button path {
    fill: currentColor;
  }

  && button:hover:enabled {
    background: rgba(255, 255, 255, 0.14);
    border-color: transparent;
    color: #fff;
  }

  && button:active:enabled {
    background: rgba(255, 255, 255, 0.22);
    border-color: transparent;
    color: #fff;
  }
`;
